import { post } from "@selector/shared";

import type { components } from "@/openapi";

export type UserGroupIntersectionResponse =
  components["schemas"]["GenomeUsergroupIntersectionResponse"]["commonUsergroups"];
export type UserGroupPayload = components["schemas"]["GenomeUsergroupIntersectionRequest"];

export async function postSelectableUserGroups(payload: UserGroupPayload): Promise<UserGroupIntersectionResponse> {
  return post("/genome/usergroupIntersection", undefined, undefined, { ...payload }).then(
    ({ data }) => data?.commonUsergroups,
  );
}
